export const GET_STEPPER = 'STEPPER';
export const GET_ACTIVE_STEP = 'ACTIVE_STEP';
